import { MouseEvent, useCallback } from 'react';

import { Action, Target, useTrackInteraction } from '~/hooks/useTrackInteraction/useTrackInteraction';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

interface UseSearchResultsProps {
  hit: {
    parent: {
      id: string;
    };
    title: string;
  };
  target:
    | Target.SEARCH_RESULT_CONTRACT
    | Target.SEARCH_RESULT_PURCHASE_ORDER
    | Target.SEARCH_RESULT_PURCHASE_REQUISITION;
}

export const useTrackSearchResults = ({ hit, target }: UseSearchResultsProps) => {
  const track = useTrackInteraction();

  const handleTrackEvent = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      track(target, Action.SEARCH_RESULT_CLICKED, {
        id: hit.parent.id,
        title: hit.title,
      });
      eventStopPropagation(event);
    },
    [track, hit, target],
  );

  return handleTrackEvent;
};
